import { ValueOfKey } from '../../utils-types';

export const SCAN_IQ_PAYMENT_RESULT_TYPE = {
  FREE: 'FREE',
  WITH_PAYMENT: 'WITH_PAYMENT',
  ALREADY_SUBSCRIBED: 'ALREADY_SUBSCRIBED',
} as const;

export type ScanIqPaymentResultType = ValueOfKey<typeof SCAN_IQ_PAYMENT_RESULT_TYPE>;
